import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

export class SummaryModel {
    public SummaryId: number;
    public Date: Date;
    public SummaryValue: string;
    public AccountId: number;
    public SiteId: number;
}

export class SummaryFilterModel {
    public date: NgbDateStruct;
    public accountId: number;
    public siteId: number;
}



// WEBPACK FOOTER //
// ./src/app/models/summaryModel.ts